export const projects = [
    {
        id: 'escapade',
        title: 'Escapade',
        description: 'Escapade - A property management platform',
        category: 'web',
        imageUrl: 'https://github.com/PushpakB3096/escapade/assets/44138832/d52a4bf3-69bd-4cf1-b5fc-6365561fd862',
        tags: ['React', 'Tailwind', 'NodeJS'],
        date: '2023',
        overview: "Escapade is built using a powerful tech stack to provide a comprehensive and user-friendly platform for property reservations and management. This application serves both travelers seeking accommodation and property owners managing their listings.",
        features: [
            {
                title: 'Property Listings',
                description: 'Easily list and manage properties with custom details and pricing options.'
            },
            {
                title: 'Reservation System',
                description: 'A streamlined booking process for travelers to reserve accommodations efficiently.'
            },
            {
                title: 'User Authentication',
                description: 'Secure authentication for property owners and travelers using modern protocols.'
            },
            {
                title: 'Admin Dashboard',
                description: 'An intuitive dashboard for administrators to oversee property and user activity.'
            }
        ],
        technologies: ['React', 'TypeScript', 'Tailwind', 'Prisma', 'Node.js', 'MongoDB'],
        demoLink: 'https://escapade-project.vercel.app/',
        githubLink: 'https://github.com/PushpakB3096/escapade',
        gallery: [
            'https://github.com/PushpakB3096/escapade/assets/44138832/d52a4bf3-69bd-4cf1-b5fc-6365561fd862',
            'https://github.com/PushpakB3096/escapade/assets/44138832/671b67e2-cfd8-40fd-bf82-80b2869c2f2b'
        ]
    },
    {
        id: 'synq',
        title: 'Synq',
        description: 'Synq - Real-time Communication Platform',
        category: 'web',
        imageUrl: 'https://github.com/PushpakB3096/synq/assets/44138832/f67f30e2-9ab0-4d0e-a53c-dde9a5e1288b',
        tags: ['React', 'Tailwind', 'NodeJS'],
        date: '2023',
        overview: "Synq is a real-time communication platform designed to connect communities, friends, and teams seamlessly. It offers advanced features for chat, collaboration, and management of interactions.",
        features: [
            {
                title: 'Real-time Messaging',
                description: 'Send and receive messages instantly with robust WebSocket integration.'
            },
            {
                title: 'Group Communication',
                description: 'Create groups to facilitate team discussions and community interactions.'
            },
            {
                title: 'Video Conferencing',
                description: 'Integrated video call feature for virtual meetings and online collaboration.'
            },
            {
                title: 'File Sharing',
                description: 'Effortlessly share documents and media files in real-time with your network.'
            }
        ],
        technologies: ['React', 'TypeScript', 'NextJS', 'SocketIO', 'ShadcnUI', 'MySQL'],
        demoLink: 'https://synq.up.railway.app/',
        githubLink: 'https://github.com/PushpakB3096/synq',
        gallery: [
            'https://github.com/PushpakB3096/synq/assets/44138832/f67f30e2-9ab0-4d0e-a53c-dde9a5e1288b',
            'https://github.com/PushpakB3096/synq/assets/44138832/55b258eb-f02f-4423-90e5-d85f32cc78fd',
            "https://github.com/PushpakB3096/synq/assets/44138832/a2bc9e81-f295-45b7-8258-69ead8c0d2ad",
            "https://github.com/PushpakB3096/synq/assets/44138832/5bb11678-d97a-4563-a28f-0fad7df4764a",
            "https://github.com/PushpakB3096/synq/assets/44138832/79d31edf-52af-4a5a-9c75-a97851ea48f1"
        ]
    },
    {
        id: 'expense-tracker-voice',
        title: 'Expense Tracker',
        description: "Expense Tracker with Voice Integration and NLP",
        category: 'web',
        imageUrl: 'https://private-user-images.githubusercontent.com/44138832/278571835-f67f30e2-9ab0-4d0e-a53c-dde9a5e1288b.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3MzQzNjU4MTcsIm5iZiI6MTczNDM2NTUxNywicGF0aCI6Ii80NDEzODgzMi8yNzg1NzE4MzUtZjY3ZjMwZTItOWFiMC00ZDBlLWE1M2MtZGRlOWE1ZTEyODhiLnBuZz9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1DcmVkZW50aWFsPUFLSUFWQ09EWUxTQTUzUFFLNFpBJTJGMjAyNDEyMTYlMkZ1cy1lYXN0LTElMkZzMyUyRmF3czRfcmVxdWVzdCZYLUFtei1EYXRlPTIwMjQxMjE2VDE2MTE1N1omWC1BbXotRXhwaXJlcz0zMDAmWC1BbXotU2lnbmF0dXJlPTdiNWZmMTE1YWU4YjA2NWNhODMxZGQ5ODBlMGY4ZDU1OGQ3M2Q1NTZlNDk5ZmVlYjFmNjJhODUwM2E4MDY2MGEmWC1BbXotU2lnbmVkSGVhZGVycz1ob3N0In0.JjZJA-JXUpPNkIQocZvKKIwLcW6sbcdUxaQj0UVIkYg',
        tags: ['React', 'Tailwind', 'NodeJS'],
        date: '2022',
        overview: "A feature-rich expense tracker that leverages Speechly for voice input and natural language processing. It simplifies expense tracking with voice commands, storing data locally for offline use and offering visual analytics.",
        features: [
            {
                "title": "Voice Integration",
                "description": "Add expenses effortlessly using voice commands with Speechly."
            },
            {
                "title": "Natural Language Processing",
                "description": "Understand and process voice inputs for automatic field population."
            },
            {
                "title": "Data Persistence",
                "description": "Store expense data in localStorage for easy access and offline functionality."
            },
            {
                "title": "Interactive Charts",
                "description": "Visualize spending patterns using ChartJS for better financial management."
            }
        ],
        technologies: ['React', 'Speechly', 'ChartJS', 'Context API', 'MaterialUI', 'MySQL'],
        demoLink: 'https://voice-expense-tracker-react.netlify.app/',
        githubLink: 'https://github.com/PushpakB3096/react-voice-exp-tracker',
        gallery: []
    }
];

export const projectCategories = [
    { id: 'all', label: 'All' },
    { id: 'web', label: 'Web Apps' },
    { id: 'mobile', label: 'Mobile' },
];

// Helper function to get project details by ID
export const getProjectById = (id) => {
    return projects.find(project => project.id === id);
}; 